import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import CustomerSchedule from 'components/CustomerSchedule'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import CutileiLogo from 'icons/logo-cutilei-simple.png'
import RateScheduleModal from 'pages/Modals/RateScheduleModal'

import {
  Container,
  SubContainer,
  SchedulesGrid,
  LogoRow,
  SmallImage,
  Title,
  InfoText
} from './styles'

export default function CustomerSchedules () {
  const { customer_id } = useParams ()
  const [loading, setLoading] = useState (true)
  const [customer, setCustomer] = useState ({})
  const [schedules, setSchedules] = useState ([])
  const [ratingData, setRatingData] = useState ({})
  const navigate = useNavigate ()

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      const { data: customer } = await cutileiApi.get (`/customers/${customer_id}`)
      const { data: schedules } = await cutileiApi.get (
        `/customers/${customer_id}/schedules`
      )

      setCustomer (customer)
      setSchedules (schedules.data)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const handleEditSchedule = schedule => {
    const { business } = schedule
    navigate (`/businesses/${business.id}/schedule/${schedule.id}`)
  }

  const handleRateSchedule = ratingData => {
    setRatingData (ratingData)
  }

  const handleScheduleRated = ratings => {
    const { schedule } = ratingData
    const { businessRating, professionalRating } = ratings

    const updatedSchedule = {
      ...schedule,
      businessRating,
      professionalRating
    }

    setSchedules (schedules.map (s => (s.id === updatedSchedule.id ? updatedSchedule : s)))
    setRatingData ({})
  }

  const handleDeleteSchedule = schedule => {
    setSchedules (schedules.filter (s => s.id !== schedule.id))
  }

  return (
    <Container>
      <LogoRow>
        <SmallImage src={CutileiLogo} alt='Cutilei'/>
        <Title style={{margin: 0}}>Cutilei</Title>
      </LogoRow>
      {loading ? (
        <Loading style={{marginTop: 20}}/>
      ) : (
        <SubContainer>
          <Title>Olá, {customer.name.split (' ')[0]}!</Title>
          <InfoText>
            Você pode acompanhar, alterar ou cancelar seus agendamentos por aqui
          </InfoText>
          {schedules.length > 0 ? (
            <SchedulesGrid total={schedules.length}>
              {schedules.map ((schedule, index) => (
                <CustomerSchedule
                  key={index}
                  data={schedule}
                  showActions={true}
                  onEdit={handleEditSchedule}
                  onRate={handleRateSchedule}
                  onDelete={handleDeleteSchedule}
                />
              ))}
            </SchedulesGrid>
          ) : (
            <InfoText style={{marginTop: 20}}>
              Você ainda não possui agendamentos marcados
            </InfoText>
          )}
        </SubContainer>
      )}
      <RateScheduleModal
        visible={!!ratingData.schedule}
        schedule={ratingData.schedule}
        navigateTo={ratingData.navigateTo}
        onConfirm={handleScheduleRated}
        onClose={() => setRatingData ({})}
      />
    </Container>
  )
}
